import { render, staticRenderFns } from "./TheDappBlockHeader.vue?vue&type=template&id=32f19f3c&scoped=true"
import script from "./TheDappBlockHeader.vue?vue&type=script&lang=js"
export * from "./TheDappBlockHeader.vue?vue&type=script&lang=js"
import style0 from "./TheDappBlockHeader.vue?vue&type=style&index=0&id=32f19f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f19f3c",
  null
  
)

export default component.exports